export default __webpack_public_path__ + "static/media/banner3.b8ad0020.webp";